import { getHasBreakingError } from 'globalUtils';
import { connect } from 'react-redux';
import App from './App';

const mapStateToProps = (state) => ({
  hasBreakingError: getHasBreakingError(state.global.breakingErrors),
});

export default connect(mapStateToProps)(App);
